module.exports = __webpack_public_path__ + "img/Icon-Done.635a9b5e.svg";